import React from 'react';
import './Error.scss';

const Error = () => (
    <div className='error-container'>
     <h6 className='error-title'>
        Ops! Algo fora do comum aconteceu com nossos servidores. Voltaremos em breve!
      </h6>
    </div>
);



export default Error;